export default function getElementPositionRelativeToParent(element) {
  const element_position = element.getBoundingClientRect();
  const parent_position = element.parentElement.getBoundingClientRect();

  return {
    x: element_position.x - parent_position.x,
    y: element_position.y - parent_position.y
  };
}
